import React from 'react';
import styled from '@emotion/styled';
import { mq, innerContentWidthPc } from 'style/variables';
import { contentWrapper } from 'style/mixin';
import sizes from 'style/sizes';
import { EnHeading } from 'components/atoms/enHeading';
import { DataNumber } from 'components/atoms/dataNumber';

type ProjectDetailNumbersProps = {
  title: string;
  numbers: Array<NumbersObject>;
  numbersCol: number;
  isJa?: boolean; // JPのみ新しくスタイルの修正を加えたいため専用のbooleanでスタイル出し分け
};

export type NumbersObject = {
  title: string;
  number: string;
  isPlus?: boolean;
  isMinus?: boolean;
  unit?: string;
};

const Container = styled.div`
  ${contentWrapper}
  margin-bottom: ${parseInt(sizes.margin[209]) - parseInt(sizes.margin[64])}px;
  ${mq.onlysp} {
    margin-bottom: 91px;
  }
`;

const Title = styled.div`
  margin-bottom: ${sizes.margin[56]};
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[44]};
  }
`;

const Inner = styled.div`
  max-width: ${innerContentWidthPc}px;
  margin: auto;
`;

const NumbersCol = styled.div<ProjectDetailNumbersProps>`
  ${mq.onlypc} {
    display: flex;
    flex-wrap: wrap;
  }
  & > div {
    margin-bottom: ${sizes.margin[64]};
    ${mq.onlypc} {
      width: calc((100% / ${props => props.numbersCol}));
    }
    ${mq.onlysp} {
      margin-bottom: ${sizes.margin[49]};
    }
  }
`;

export const ProjectDetailNumbers: React.FC<ProjectDetailNumbersProps> = props => {
  return (
    <Container>
      <Title>
        <EnHeading>{props.title}</EnHeading>
      </Title>
      <Inner>
        <NumbersCol {...props}>
          {props.numbers.map((item, idx) => (
            <DataNumber
              key={idx}
              title={item.title}
              number={item.number}
              isPlus={item.isPlus}
              isMinus={item.isMinus}
              unit={item.unit}
              isJa={props.isJa}
            />
          ))}
        </NumbersCol>
      </Inner>
    </Container>
  );
};
